import {
  ChangeDetectionStrategy,
  Component,
  EnvironmentProviders,
  input,
  makeEnvironmentProviders,
  Type,
} from '@angular/core';

import { z } from 'zod';

import {
  provideTellentToolResultRenderer,
  ToolResultRenderer,
} from '@core/tellent-assistant-contracts';

import { ChatTicketItemDynamicComponent } from '../chat/chat-ticket-item-dynamic/chat-ticket-item-dynamic.component';

const requestTicketDescriptorSchema = z.object({
  name: z.literal('request-ticket'),
  props: z.object({ id: z.number() }),
});

type RequestTicketDescriptor = z.infer<typeof requestTicketDescriptorSchema>;

@Component({
  selector: 'tellent-assistant-ticket-renderer',
  standalone: true,
  imports: [ChatTicketItemDynamicComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ask-chat-request-item-dynamic [props]="payload().props" />`,
})
export class TellentAssistantTicketRendererComponent {
  public readonly payload = input.required<RequestTicketDescriptor>();
}

export function provideTellentTicketCardRenderer(): EnvironmentProviders {
  const renderer: ToolResultRenderer<RequestTicketDescriptor> = {
    toolName: 'format_request_ticket',
    schema: requestTicketDescriptorSchema,
    component: <Type<{ payload: RequestTicketDescriptor }>>(
      (<unknown>TellentAssistantTicketRendererComponent)
    ),
  };
  return makeEnvironmentProviders([provideTellentToolResultRenderer({ useValue: renderer })]);
}
